module.exports = __webpack_public_path__ + "assets/img/next_month.0cc150a3.svg";